module.exports = __webpack_public_path__ + "static/retirement1-1edfed203e86e6bffe66f331274a7296.png";